module.exports = __webpack_public_path__ + "img/b342bff.png";